import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, Alert, IconButton, Skeleton } from "@mui/material";
import { Sync } from "@mui/icons-material";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { AuthContext } from "../../context/AuthContext";
import { useSnackbar } from "notistack";
import axios from "axios";

const GridItem = (props) => {
	return (
		<Alert
			severity={props.isLoading ? "" : props.variant}
			icon={false}
			variant={"filled"}
			action={
				props.isLoading ? (
					<Skeleton width={30} height={30} variant="rounded" />
				) : (
					<Typography sx={{ marginRight: "12px", marginTop: "6px" }}>
						{props.count}
					</Typography>
				)
			}
		>
			{props.isLoading ? (
				<Skeleton width={250} />
			) : (
				<Typography>{props.title}</Typography>
			)}{" "}
		</Alert>
	);
};

const metaData = {
	withReceipt: {
		title: "صادر شده",
		variant: "primary",
	},
	withoutReceipt: {
		title: "صادر نشده",
		count: Math.floor(Math.random() * 100) + 1,
		variant: "primary",
	},
	paid: {
		title: "پرداخت شده",
		variant: "success",
	},
	notPaid: {
		title: "پرداخت نشده",
		variant: "error",
	},
};

const FactorsSummary = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState({
		withReceipt: null,
		withoutReceipt: null,
		paid: null,
		notPaid: null,
	});
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();

	const getData = async () => {
		setIsLoading(true);
		await axios
			.post("/api/v1/laboratorys/get-reciept-cards", undefined, {
				headers: {
					"Content-Type": "application/json",
					Authorization: auth.token,
				},
			})
			.then((response) => setData(response.data.data))
			.catch((e) => {
				const messages = e.response.data.data;
				messages.map((message) =>
					enqueueSnackbar(message, { variant: "error" })
				);
			})
			.finally(() => setIsLoading(false));
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<Box
			display={"flex"}
			flexDirection={"column"}
			gap={4}
			alignItems={"flex-start"}
		>
			<Grid
				container
				width={"100%"}
				spacing={4}
				p={0}
				justifyContent={"space-between"}
			>
				<Grid>
					<Typography component={"h5"} variant="h5">
						خلاصه وضعیت فاکتورها
					</Typography>
				</Grid>
				<Grid px={0}>
					<IconButton
						size="small"
						onClick={getData}
						aria-label="refetch dashboard summary"
					>
						<Sync fontSize="small" />
					</IconButton>
				</Grid>
			</Grid>
			<Grid container width={"100%"} spacing={2} p={0}>
				{Object.keys(data).map((d, i) => (
					<Grid xs={12} sm={6} md={3} key={i}>
						<GridItem
							count={data[d]}
							title={metaData[d].title}
							variant={metaData[d].variant}
							isLoading={isLoading}
						/>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default FactorsSummary;
